export const sanitizeError = (error: unknown): Record<string, any> => {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }

  // Handle non-Error objects
  if (typeof error === 'object' && error !== null) {
    return {
      ...error,
    };
  }

  // Handle primitive types (e.g., string, number)
  return {
    message: String(error),
  };
};
